import { goRequest, goClient } from '../utils/httpClientTs';
import {
  PEOReportListResponse,
  ReportMetadata,
  ExecuteReportRequest,
  ExecuteReportResponse,
  EmailExportResponse,
} from '../types/peoReports';

export const getPEOReportList = async (): Promise<PEOReportListResponse> => {
  return goRequest<PEOReportListResponse>({
    url: '/api/reports',
    method: 'GET',
  });
};

export const getPEOReportMetadata = async (
  reportId: string
): Promise<ReportMetadata> => {
  return goRequest<ReportMetadata>({
    url: `/api/reports/${reportId}`,
    method: 'GET',
  });
};

export const executePEOReport = async (
  reportId: string,
  params: ExecuteReportRequest
): Promise<ExecuteReportResponse> => {
  return goRequest<ExecuteReportResponse>({
    url: `/api/reports/${reportId}/execute`,
    method: 'POST',
    data: params,
  });
};

export const exportPEOReportEmails = async (
  reportId: string,
  params: Omit<ExecuteReportRequest, 'format'>
): Promise<EmailExportResponse> => {
  return goRequest<EmailExportResponse>({
    url: `/api/reports/${reportId}/execute`,
    method: 'POST',
    data: { ...params, format: 'emails' },
  });
};

/**
 * Downloads report as PDF (binary). Only supported for Active/Inactive Chapter Members.
 * Uses responseType: 'blob' so the response is not parsed as JSON.
 */
export const downloadPEOReportPDF = async (
  reportId: string,
  params: Omit<ExecuteReportRequest, 'format'>
): Promise<Blob> => {
  try {
    const response = await goClient.post<Blob>(
      `/api/reports/${reportId}/execute`,
      { ...params, format: 'pdf' },
      { responseType: 'blob' }
    );
    return response.data;
  } catch (err: any) {
    const data = err.response?.data;
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const json = JSON.parse(text);
        throw new Error(json.error || text);
      } catch {
        throw new Error(text || 'PDF download failed');
      }
    }
    throw err;
  }
};
